import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Promocodes',
  tabs: {
    active: 'Actief',
    expired: 'Verlopen',
    email_sign_up: 'Promo e-mailaanmelding',
  },
  show_master_promo_code: 'Masterpromocode aan klanten tonen',
  send_rejected_order_apologies_promo_code: 'Promocode verzenden bij handmatig geweigerde bestelling',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Campagne',
        [PromoCodeTag.OneTime]: 'Eenmalig',
      },
    },
    code: {
      placeholder: 'Code',
    },
    campaign: {
      placeholder: 'Campagne',
    },
    created_by: {
      placeholder: 'Aangemaakt door',
      options: {
        [PromoCodeCreatedBy.User]: 'Gebruiker',
        [PromoCodeCreatedBy.System]: 'Systeem',
      },
    },
  },
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Kortingstype',
    discount: 'Korting',
    usage_threshold: 'Gebruiksdrempel',
    quantity: 'Aantal',
    expires_at: 'Verloopt',
    level: 'Niveau',
    max_discount: 'Max. korting',
    created_by: 'Aangemaakt door',
    image: 'Afbeelding',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Campagne',
    [PromoCodeTag.OneTime]: 'Eenmalig',
  },
  types: {
    single_use: 'Eenmalig gebruik',
    multi_use: 'Meervoudig gebruik',
    unknown: 'Onbekend',
  },
  discount_types: {
    fixed_amount: 'Vast bedrag',
    percentage: 'Percentage',
    unknown: 'Onbekend',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Gebruiker',
    [PromoCodeCreatedBy.System]: 'Systeem',
  },
  labels: {
    discount: 'Korting',
    usage_threshold: 'Gebruiksdrempel',
    company: 'Bedrijf',
    restaurant: 'Restaurant',
    restaurant_group: 'Merk',
  },
  buttons: {
    add: 'Toevoegen',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    restore: 'Herstellen',
    add_promo_code: 'Promocode toevoegen',
    images: 'Afbeelding beheren',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_save_settings: 'Wijzigingen opslaan mislukt',
    failed_to_delete_promo_code: 'Promotiecode verwijderen mislukt',
    failed_to_restore_promo_code: 'Promotiecode herstellen mislukt',
    promo_code_got_deleted: 'Promotiecode verwijderd',
    promo_code_got_restored: 'Promotiecode hersteld',
  },
  delete_confirmation: {
    title: 'Promotiecode verwijderen?',
    buttons: {
      yes: 'Ja',
      no: 'Nee',
    },
  },
  restore_confirmation: {
    title: 'Promotiecode herstellen?',
    buttons: {
      yes: 'Ja',
      no: 'Nee',
    },
  },
};
